import { Component,PLATFORM_ID ,Inject } from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';

@Component({
  selector: 'scorecard',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent, 
    MatProgressSpinnerModule,
    HttpClientModule],
  templateUrl: './scorecard.component.html',
  styleUrl: './scorecard.component.css'
})
export class ScorecardComponent {
  isScreenLarge: boolean = false;

  isLessThan100Words: boolean = true;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  isIconRotated = false;

  short_words: boolean;

  no_project: boolean;

  many_errors: boolean = false;

  verifyLoaderActive2: boolean;

  public scorecard = {
    summary:{
      percentage: null,
      metrics: null,
      cefr_level: null,
    },
    metricsUsage:null,
    statistics:null,
    readability: null,
    evp:null,
    bnc:null,
    coca:null,
    awl:null,
    metadiscourse:null,
    to_short_error:false,
  }

  public errors = {
    cantidad:null
  }

  currentAnalysisMode: string;

  public percentage: number | undefined | null;
  public metrics: number | undefined | null;
  public cefr_level: string | undefined | null;

  public averageSyllablesPerSentence: number | undefined | null;
  public syllablesPer100Words: number | undefined | null;
  public wordsWithMoreThan2SyllablesPercentage: number | undefined | null;

  public flesch_reading: number | undefined | null;
  public flesch_kincaid: number | undefined | null;
  project_data: any;

  public cantidad: number | undefined | null;
  private proyectoSub;
  constructor( 
    @Inject(PLATFORM_ID) private platformId: Object,private analysisService: AnalysisServiceService,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService:ProyectosService
    ){}

  ngOnInit(): void {
    // this.percentage = this.datos_pagina.percentage;
    // this.metrics = this.datos_pagina.metrics;
    // this.cefr_level = this.datos_pagina.cefr_level;

    // this.averageSyllablesPerSentence = this.datos_pagina_statistics.averageSyllablesPerSentence;
    // this.syllablesPer100Words = this.datos_pagina_statistics.syllablesPer100Word;
    // this.wordsWithMoreThan2SyllablesPercentage = this.datos_pagina_statistics.wordsWithMoreThan2SyllablesPercentage;

    // this.flesch_reading= this.datos_pagina_readability.flesch_reading;
    // this.flesch_kincaid = this.datos_pagina_readability.flesch_kincaid;
    localStorage.setItem("actual","score")
    this.isButtonDisabled();
    this.initSubscribe();
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });

    this.proyectoService.wordCount$.subscribe(isLessThan100 => {
      this.isLessThan100Words = isLessThan100;
    });
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
      this.no_project = false;
    }else{
      this.no_project = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

            this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

            this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

     setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "score" && sessionStorage.getItem("score") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2){
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.iniciarScoreCard()
      }
      }, 20 * 1000); // 30 segundos
  }

  getObjectKeys(obj: any): string[] {
    try {
      return Object.keys(obj);
    } catch (error) {
      return [];
    }
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject })=>{
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Update de data --Reporta: Summary--")
        this.project_data = proyecto;
        if(sessionStorage.getItem("id_project")){
        this.iniciarScoreCard();
        }
      });
    }
  }

status: any;
status2: any;
  async iniciarScoreCard() {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "score"){
     // Intentar recuperar el resumen desde sessionStorage
  const memoryStorage = sessionStorage.getItem("score");
  if (memoryStorage) {
    if(memoryStorage !== "-"){
    try {
      this.loaderActiveFirstProject = false;
       // Si existe, convertirlo de JSON string a objeto y asignarlo
      let respuesta = JSON.parse(memoryStorage);
      this.scorecard = respuesta;
      this.short_words = this.scorecard.to_short_error;
      if(this.errors.cantidad >= 18){
        this.many_errors = true;
      }else{
        this.many_errors = false;
      }
    } catch (error) {
      console.log("Error al recuperar datos")
      console.log(error)
      if (error instanceof TypeError) {
        console.error("❌ TypeError: problema con el tipo de datos o red");
        console.error(error.message);
      } else if (error.message && error.message.startsWith("Error del servidor")) {
        console.error("❌ Error de servidor");
        console.error(error.message);
        sessionStorage.removeItem('score');
      } else {
        console.error("❌ Otro tipo de error:");
        console.error(error);
        sessionStorage.removeItem('score');
      }
    }finally{
      this.loaderActive2 = false;
      this.loaderActive = false;
      this.loaderActiveFirstProject = false;
      this.proyectoService.updateloader(false);
    }
  }
  }
  else{
    sessionStorage.setItem("score", "-");
      // this.proyectoService.getinfo(this.http,1,"")
    try {
      let textUID = sessionStorage.getItem('text_UID');
      let respuesta = await this.fachada.getScoreCardOfProject(this.http,textUID,"");
      this.iniciarErrors()
      // Guardar la respuesta en sessionStorage
      sessionStorage.setItem("score", JSON.stringify(respuesta));
      this.scorecard = respuesta;
      this.short_words = this.scorecard.to_short_error;
     
      this.status = 200
    } catch (error) {
      console.log("Error al recuperar datos")
      console.log(error)
       if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (score)");
            sessionStorage.removeItem('score');
            this.status = 0

          }
      else if (error instanceof TypeError) {
        console.error("❌ TypeError: problema con el tipo de datos o red");
        console.error(error.message);
      } else if (error.message && error.message.startsWith("Error del servidor")) {
        console.error("❌ Error de servidor");
        console.error(error.message);
        sessionStorage.removeItem('score');
      } else {
        console.error("❌ Otro tipo de error:");
        console.error(error);
        sessionStorage.removeItem('score');
      }
      this.status = error?.status;
    }finally{
      if(this.status === 0){
        this.loaderActive2 = true;
        this.loaderActive = true;
        this.loaderActiveFirstProject = true;
        this.proyectoService.updateloader(true);
        setTimeout(() => {
              this.iniciarScoreCard();
            }, 100);
      }else{
        this.loaderActive2 = false;
        this.loaderActive = false;
        this.loaderActiveFirstProject = false;
        this.proyectoService.updateloader(false);
         setTimeout(() => {
              this.iniciarScoreCard();
            }, 100);
      }
      
      
    }
  }
     }else{
      console.log(`score no es la pantalla actual así que bloqueamos peticiones`)
    }
    
  }

  async iniciarErrors(){
    try {
      let textUID = sessionStorage.getItem('text_UID');
      let respuestaErrors = await this.fachada.getErrorsOfProject(this.http,textUID,"");
      this.errors = respuestaErrors
       if(this.errors.cantidad >= 18){
        this.many_errors = true;
      }else{
        this.many_errors = false;
      }
      this.status2 = 200
    } catch (error) {
         if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (errors)");
            this.status2 = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
          }
          this.status2 = error?.status;
      
    }
    finally{
      if(this.status2 === 0){
       setTimeout(() => {
              this.iniciarErrors();
            }, 100);
      }
    }
  }
  
  toggleIcon() {
    this.isIconRotated = !this.isIconRotated;
  }

  resetIcon() { this.isIconRotated = false; }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }


  isMatchingLevel(level): boolean {
    let temp = this.scorecard.summary.cefr_level.split("+")[0]
    return level === temp;
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

  exportar_data(){
    let proyecto = sessionStorage.getItem("text_UID")
    if (proyecto){
      this.fachada.export_general([false,false,false,false,false,false,false,false,false,false,true], proyecto)
    }else{
      console.log("No hay un proyecto cargado")
    }
  }

}
